import React from 'react';

// Progress Stepper Component
export const ProgressStepper = ({ steps, currentStep }) => {
    return (
        <div className="row mb-4 mt-3">
            <div className="col-12">
                <div className="d-flex justify-content-between align-items-center" style={{ position: 'relative' }}>
                    {steps.map((step, index) => (
                        <div key={step.number} className="d-flex flex-column align-items-center" style={{ flex: 1, position: 'relative', zIndex: 1 }}>
                            <div
                                className="d-flex align-items-center justify-content-center"
                                style={{
                                    width: '50px',
                                    height: '50px',
                                    borderRadius: '50%',
                                    backgroundColor: currentStep >= step.number ? '#0b7e45' : '#e0e0e0',
                                    color: currentStep >= step.number ? '#fff' : '#999',
                                    fontWeight: '600',
                                    fontSize: '18px',
                                    transition: 'all 0.3s ease',
                                    boxShadow: currentStep === step.number ? '0 5px 15px rgba(9, 108, 58, 0.3)' : 'none'
                                }}
                            >
                                {currentStep > step.number ? '✓' : step.number}
                            </div>
                            <span
                                style={{
                                    marginTop: '8px',
                                    fontSize: '13px',
                                    fontWeight: currentStep === step.number ? '600' : '400',
                                    color: currentStep >= step.number ? '#0b7e45' : '#999',
                                    textAlign: 'center'
                                }}
                            >
                                {step.title}
                            </span>
                            {index < steps.length - 1 && (
                                <div
                                    style={{
                                        position: 'absolute',
                                        top: '25px',
                                        left: 'calc(50% + 25px)',
                                        width: 'calc(100% - 50px)',
                                        height: '3px',
                                        backgroundColor: currentStep > step.number ? '#0b7e45' : '#e0e0e0',
                                        transition: 'all 0.3s ease',
                                        zIndex: -1
                                    }}
                                />
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

// Step Navigation Buttons Component
export const StepNavigation = ({ currentStep, totalSteps, onPrev, onNext, onPreview, disableNext, isSubmitting }) => {
    return (
        <div className="row mt-4 mb-3">
            <div className="col-12 d-flex justify-content-between">
                {currentStep > 1 && (
                    <button
                        type="button"
                        onClick={onPrev}
                        disabled={isSubmitting}
                        className="btn"
                        style={{
                            background: '#f5f9f7',
                            color: '#0b7e45',
                            border: '1px solid #0b7e45',
                            padding: '10px 30px',
                            fontWeight: '600',
                            borderRadius: '4px',
                            opacity: isSubmitting ? 0.6 : 1
                        }}
                    >
                        ← Previous
                    </button>
                )}
                <div style={{ flex: 1 }} />
                {currentStep < totalSteps ? (
                    <button
                        type="button"
                        onClick={onNext}
                        disabled={disableNext}
                        className="btn"
                        style={{
                            background: disableNext ? '#e0e0e0' : 'linear-gradient(to right, #4eca8c 0%, #9be368 100%)',
                            color: disableNext ? '#999' : '#fff',
                            border: 'none',
                            padding: '10px 30px',
                            fontWeight: '600',
                            borderRadius: '4px',
                            cursor: disableNext ? 'not-allowed' : 'pointer'
                        }}
                    >
                        Next Step →
                    </button>
                ) : (
                    <button
                        type="button"
                        onClick={onPreview}
                        disabled={disableNext || isSubmitting}
                        className="btn d-flex align-items-center gap-2"
                        style={{
                            background: (disableNext || isSubmitting) ? '#e0e0e0' : 'linear-gradient(to right, #096c3a 0%, #0b7e45 100%)',
                            color: (disableNext || isSubmitting) ? '#999' : '#fff',
                            border: 'none',
                            padding: '10px 30px',
                            fontWeight: '600',
                            borderRadius: '4px',
                            cursor: (disableNext || isSubmitting) ? 'not-allowed' : 'pointer'
                        }}
                    >
                        {isSubmitting ? (
                            <>
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                Registering...
                            </>
                        ) : (
                            'Confirm & Register →'
                        )}
                    </button>
                )}
            </div>
        </div>
    );
};
